<div @scaleOut id="vex-splash-screen" class="splash-screen inner-splash-screen content-loader z-10">
  <div class="wrapper">
    <div class="ball-scale-multiple">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
